import { useEffect, useState } from 'react';
import { FaMapMarkerAlt } from 'react-icons/fa';
import PlacesAutocomplete from 'react-places-autocomplete';
import poweredByGoogle from 'src/assets/images/powered_by_google.png';
const AddressSearchField = ({ setPlaceId }) => {
  const [address, setAddress] = useState('');
  const [loaded, setLoaded] = useState(false);
  const apiKey = process.env.GMAPS_API_KEY;

  useEffect(() => {
    if (window.google?.maps?.places) {
      setLoaded(true);
      return;
    }

    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
    script.async = true;
    script.onload = () => {
      if (window.google?.maps?.places) setLoaded(true);
    };
    document.body.appendChild(script);
  }, [apiKey]);

  if (!loaded) return null;

  return (
    <PlacesAutocomplete
      value={address}
      onChange={setAddress}
      onSelect={async (address, placeId) => {
        setPlaceId(placeId);
        setAddress(address);
      }}
    >
      {({ getInputProps, suggestions, getSuggestionItemProps }) => (
        <div className="relative">
          <input
            {...getInputProps({
              placeholder: 'Type an address',
              className:
                'w-full p-2 border overflow-visible rounded focus:outline-none focus:ring focus:border-blue-400',
            })}
          />
          {suggestions.length > 0 && (
            <div className="absolute left-0 right-0 bg-white shadow-lg z-10">
              {suggestions.map((s) => (
                <div
                  key={s.placeId}
                  {...getSuggestionItemProps(s, {
                    className: 'p-2 hover:bg-gray-100 flex items-center gap-2 cursor-pointer',
                  })}
                >
                  <FaMapMarkerAlt className="text-gray-500" />
                  <span className="">{s.formattedSuggestion.mainText}</span>
                  <span className="text-gray-500 text-xs">
                    {s.formattedSuggestion.secondaryText}
                  </span>
                </div>
              ))}
              <div className="flex justify-end">
                <img src={poweredByGoogle} alt="Powered by Google" />
              </div>
            </div>
          )}
        </div>
      )}
    </PlacesAutocomplete>
  );
};

export default AddressSearchField;
